const hideElements = (elements = null, shouldHide = 'true') => {
  const elementHidden = document.querySelectorAll(`
    .menu,
    .hero,
    .intro-area,
    .support-area,
    .footer,
    #cookie-notice,
    .reachout,
    ${ elements }
  `);

  elementHidden.forEach(elem => {
    elem.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
  });
};

export default hideElements;
